module.exports = __webpack_public_path__ + "static/design-element-848651f411578c097f37850ba3807ace.svg";